/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MdmObservationBacklogResponse,
  MdmUnresolvedObservationActionResponse,
  MdmUnresolvedObservationFiltersResponse,
  MdmUnresolvedObservationsListResponse,
} from '../models/index';
import {
    MdmObservationBacklogResponseFromJSON,
    MdmObservationBacklogResponseToJSON,
    MdmUnresolvedObservationActionResponseFromJSON,
    MdmUnresolvedObservationActionResponseToJSON,
    MdmUnresolvedObservationFiltersResponseFromJSON,
    MdmUnresolvedObservationFiltersResponseToJSON,
    MdmUnresolvedObservationsListResponseFromJSON,
    MdmUnresolvedObservationsListResponseToJSON,
} from '../models/index';

export interface DismissMdmUnresolvedObservationRequest {
    id: string;
    sessionId: string;
}

export interface GetMdmObservationBacklogRequest {
    sessionId: string;
}

export interface GetMdmUnresolvedObservationRequest {
    id: string;
    sessionId: string;
}

export interface GetMdmUnresolvedObservationFiltersRequest {
    sessionId: string;
}

export interface ListMdmUnresolvedObservationsRequest {
    sessionId: string;
    status?: string;
    sourceSystem?: string;
    reasonCode?: string;
    executionId?: string;
    integrationInstanceId?: string;
    observationRoute?: string;
    page?: number;
    size?: number;
}

export interface ReplayMdmUnresolvedObservationRequest {
    id: string;
    sessionId: string;
}

export interface ReplayMdmUnresolvedObservationsRequest {
    sessionId: string;
}

/**
 * MDMPipelineApi - interface
 * 
 * @export
 * @interface MDMPipelineApiInterface
 */
export interface MDMPipelineApiInterface {
    /**
     * 
     * @summary Manually dismiss (STALE) an unresolved observation
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    dismissMdmUnresolvedObservationRaw(requestParameters: DismissMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>>;

    /**
     * Manually dismiss (STALE) an unresolved observation
     */
    dismissMdmUnresolvedObservation(requestParameters: DismissMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse>;

    /**
     * 
     * @summary Tenant observation backlog counts
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    getMdmObservationBacklogRaw(requestParameters: GetMdmObservationBacklogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmObservationBacklogResponse>>;

    /**
     * Tenant observation backlog counts
     */
    getMdmObservationBacklog(requestParameters: GetMdmObservationBacklogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmObservationBacklogResponse>;

    /**
     * 
     * @summary Get one unresolved observation
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    getMdmUnresolvedObservationRaw(requestParameters: GetMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationsListResponse>>;

    /**
     * Get one unresolved observation
     */
    getMdmUnresolvedObservation(requestParameters: GetMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationsListResponse>;

    /**
     * 
     * @summary Filter values for unresolved observation list
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    getMdmUnresolvedObservationFiltersRaw(requestParameters: GetMdmUnresolvedObservationFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationFiltersResponse>>;

    /**
     * Filter values for unresolved observation list
     */
    getMdmUnresolvedObservationFilters(requestParameters: GetMdmUnresolvedObservationFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationFiltersResponse>;

    /**
     * 
     * @summary List unresolved asset observations
     * @param {string} sessionId 
     * @param {string} [status] PENDING, RESOLVED, STALE, or PURGED
     * @param {string} [sourceSystem] 
     * @param {string} [reasonCode] 
     * @param {string} [executionId] 
     * @param {string} [integrationInstanceId] 
     * @param {string} [observationRoute] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    listMdmUnresolvedObservationsRaw(requestParameters: ListMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationsListResponse>>;

    /**
     * List unresolved asset observations
     */
    listMdmUnresolvedObservations(requestParameters: ListMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationsListResponse>;

    /**
     * 
     * @summary Replay one pending unresolved observation
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    replayMdmUnresolvedObservationRaw(requestParameters: ReplayMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>>;

    /**
     * Replay one pending unresolved observation
     */
    replayMdmUnresolvedObservation(requestParameters: ReplayMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse>;

    /**
     * 
     * @summary Replay pending unresolved observations for tenant
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMPipelineApiInterface
     */
    replayMdmUnresolvedObservationsRaw(requestParameters: ReplayMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>>;

    /**
     * Replay pending unresolved observations for tenant
     */
    replayMdmUnresolvedObservations(requestParameters: ReplayMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse>;

}

/**
 * 
 */
export class MDMPipelineApi extends runtime.BaseAPI implements MDMPipelineApiInterface {

    /**
     * Manually dismiss (STALE) an unresolved observation
     */
    async dismissMdmUnresolvedObservationRaw(requestParameters: DismissMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dismissMdmUnresolvedObservation().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling dismissMdmUnresolvedObservation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations/{id}/dismiss`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationActionResponseFromJSON(jsonValue));
    }

    /**
     * Manually dismiss (STALE) an unresolved observation
     */
    async dismissMdmUnresolvedObservation(requestParameters: DismissMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse> {
        const response = await this.dismissMdmUnresolvedObservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tenant observation backlog counts
     */
    async getMdmObservationBacklogRaw(requestParameters: GetMdmObservationBacklogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmObservationBacklogResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getMdmObservationBacklog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/observation-backlog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmObservationBacklogResponseFromJSON(jsonValue));
    }

    /**
     * Tenant observation backlog counts
     */
    async getMdmObservationBacklog(requestParameters: GetMdmObservationBacklogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmObservationBacklogResponse> {
        const response = await this.getMdmObservationBacklogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one unresolved observation
     */
    async getMdmUnresolvedObservationRaw(requestParameters: GetMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationsListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMdmUnresolvedObservation().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getMdmUnresolvedObservation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationsListResponseFromJSON(jsonValue));
    }

    /**
     * Get one unresolved observation
     */
    async getMdmUnresolvedObservation(requestParameters: GetMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationsListResponse> {
        const response = await this.getMdmUnresolvedObservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter values for unresolved observation list
     */
    async getMdmUnresolvedObservationFiltersRaw(requestParameters: GetMdmUnresolvedObservationFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationFiltersResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getMdmUnresolvedObservationFilters().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations/filters`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationFiltersResponseFromJSON(jsonValue));
    }

    /**
     * Filter values for unresolved observation list
     */
    async getMdmUnresolvedObservationFilters(requestParameters: GetMdmUnresolvedObservationFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationFiltersResponse> {
        const response = await this.getMdmUnresolvedObservationFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List unresolved asset observations
     */
    async listMdmUnresolvedObservationsRaw(requestParameters: ListMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationsListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listMdmUnresolvedObservations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['sourceSystem'] != null) {
            queryParameters['sourceSystem'] = requestParameters['sourceSystem'];
        }

        if (requestParameters['reasonCode'] != null) {
            queryParameters['reasonCode'] = requestParameters['reasonCode'];
        }

        if (requestParameters['executionId'] != null) {
            queryParameters['executionId'] = requestParameters['executionId'];
        }

        if (requestParameters['integrationInstanceId'] != null) {
            queryParameters['integrationInstanceId'] = requestParameters['integrationInstanceId'];
        }

        if (requestParameters['observationRoute'] != null) {
            queryParameters['observationRoute'] = requestParameters['observationRoute'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationsListResponseFromJSON(jsonValue));
    }

    /**
     * List unresolved asset observations
     */
    async listMdmUnresolvedObservations(requestParameters: ListMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationsListResponse> {
        const response = await this.listMdmUnresolvedObservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replay one pending unresolved observation
     */
    async replayMdmUnresolvedObservationRaw(requestParameters: ReplayMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling replayMdmUnresolvedObservation().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling replayMdmUnresolvedObservation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations/{id}/replay`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationActionResponseFromJSON(jsonValue));
    }

    /**
     * Replay one pending unresolved observation
     */
    async replayMdmUnresolvedObservation(requestParameters: ReplayMdmUnresolvedObservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse> {
        const response = await this.replayMdmUnresolvedObservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replay pending unresolved observations for tenant
     */
    async replayMdmUnresolvedObservationsRaw(requestParameters: ReplayMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MdmUnresolvedObservationActionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling replayMdmUnresolvedObservations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/pipeline/unresolved-observations/replay`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MdmUnresolvedObservationActionResponseFromJSON(jsonValue));
    }

    /**
     * Replay pending unresolved observations for tenant
     */
    async replayMdmUnresolvedObservations(requestParameters: ReplayMdmUnresolvedObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MdmUnresolvedObservationActionResponse> {
        const response = await this.replayMdmUnresolvedObservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
